import { ColDef } from 'ag-grid-community';

import { QuoteListType } from 'quotes/enums';

export const getQuoteColumnDefs = (
  allColumns: Record<string, ColDef>,
  quoteListType = QuoteListType.GLOBAL
): ColDef[] => {
  const {
    versionTypeColumn,
    statusColumn,
    quoteIdColumn,
    customerColumn,
    billToAccountNumberColumn,
    contactColumn,
    jobColumn,
    projectColumn,
    totalPriceColumn,
    userColumn,
    locationColumn,
    verticalMarketColumn,
    updatedAtColumn,
    createdAtColumn,
    archivedColumn,
    groupColumn,
    closeConfidenceColumn,
    closeDateColumn,
    validUntilColumn,
    isrColumn,
    osrColumn,
  } = allColumns;

  switch (quoteListType) {
    case QuoteListType.COPY_PARTS_TO_QUOTE:
      return [
        versionTypeColumn,
        statusColumn,
        quoteIdColumn,
        jobColumn,
        projectColumn,
        totalPriceColumn,
        updatedAtColumn,
        createdAtColumn,
        userColumn,
        locationColumn,
        groupColumn,
        verticalMarketColumn,
        closeConfidenceColumn,
        closeDateColumn,
        validUntilColumn,
        archivedColumn,
      ];
    case QuoteListType.JOB:
      return [
        versionTypeColumn,
        statusColumn,
        quoteIdColumn,
        customerColumn,
        contactColumn,
        totalPriceColumn,
        updatedAtColumn,
        createdAtColumn,
        userColumn,
        locationColumn,
        groupColumn,
        verticalMarketColumn,
        closeConfidenceColumn,
        closeDateColumn,
        validUntilColumn,
        archivedColumn,
      ];
    case QuoteListType.PROJECT:
      return [
        versionTypeColumn,
        statusColumn,
        quoteIdColumn,
        customerColumn,
        contactColumn,
        jobColumn,
        totalPriceColumn,
        updatedAtColumn,
        createdAtColumn,
        userColumn,
        locationColumn,
        groupColumn,
        verticalMarketColumn,
        closeConfidenceColumn,
        closeDateColumn,
        validUntilColumn,
        archivedColumn,
      ];
    case QuoteListType.GLOBAL:
    default:
      return [
        versionTypeColumn,
        statusColumn,
        quoteIdColumn,
        customerColumn,
        billToAccountNumberColumn,
        contactColumn,
        jobColumn,
        projectColumn,
        totalPriceColumn,
        updatedAtColumn,
        createdAtColumn,
        userColumn,
        locationColumn,
        groupColumn,
        verticalMarketColumn,
        closeConfidenceColumn,
        closeDateColumn,
        validUntilColumn,
        isrColumn,
        osrColumn,
        archivedColumn,
      ];
  }
};

export const getOrderColumnDefs = (
  allColumns: Record<string, ColDef>,
  quoteListType = QuoteListType.GLOBAL
): ColDef[] => {
  const {
    versionTypeColumn,
    statusColumn,
    externalStatusColumn,
    orderIdColumn,
    quoteIdColumn,
    customerColumn,
    contactColumn,
    jobColumn,
    projectColumn,
    totalPriceColumn,
    userColumn,
    locationColumn,
    verticalMarketColumn,
    updatedAtColumn,
    createdAtColumn,
    archivedColumn,
    customerNumberColumn,
    purchaseOrderNumberColumn,
    externalOrderNumberColumn,
    externalPendingOrderNumberColumn,
    isrColumn,
    osrColumn,
  } = allColumns;

  switch (quoteListType) {
    case QuoteListType.COPY_PARTS_TO_QUOTE:
      return [
        versionTypeColumn,
        statusColumn,
        externalStatusColumn,
        orderIdColumn,
        jobColumn,
        projectColumn,
        quoteIdColumn,
        totalPriceColumn,
        updatedAtColumn,
        createdAtColumn,
        userColumn,
        locationColumn,
        verticalMarketColumn,
        customerNumberColumn,
        purchaseOrderNumberColumn,
        externalOrderNumberColumn,
        externalPendingOrderNumberColumn,
        archivedColumn,
      ];
    case QuoteListType.JOB:
      return [
        versionTypeColumn,
        statusColumn,
        externalStatusColumn,
        orderIdColumn,
        customerColumn,
        contactColumn,
        quoteIdColumn,
        totalPriceColumn,
        updatedAtColumn,
        createdAtColumn,
        userColumn,
        locationColumn,
        verticalMarketColumn,
        customerNumberColumn,
        purchaseOrderNumberColumn,
        externalOrderNumberColumn,
        externalPendingOrderNumberColumn,
        archivedColumn,
      ];
    case QuoteListType.PROJECT:
      return [
        versionTypeColumn,
        statusColumn,
        externalStatusColumn,
        orderIdColumn,
        customerColumn,
        contactColumn,
        jobColumn,
        quoteIdColumn,
        totalPriceColumn,
        updatedAtColumn,
        createdAtColumn,
        userColumn,
        locationColumn,
        verticalMarketColumn,
        customerNumberColumn,
        purchaseOrderNumberColumn,
        externalOrderNumberColumn,
        externalPendingOrderNumberColumn,
        archivedColumn,
      ];
    case QuoteListType.GLOBAL:
    default:
      return [
        versionTypeColumn,
        statusColumn,
        externalStatusColumn,
        orderIdColumn,
        customerColumn,
        contactColumn,
        jobColumn,
        projectColumn,
        quoteIdColumn,
        totalPriceColumn,
        updatedAtColumn,
        createdAtColumn,
        userColumn,
        locationColumn,
        verticalMarketColumn,
        customerNumberColumn,
        purchaseOrderNumberColumn,
        externalOrderNumberColumn,
        externalPendingOrderNumberColumn,
        isrColumn,
        osrColumn,
        archivedColumn,
      ];
  }
};
